import { Card, Container, Divider, Stack, Switch, Typography } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import { useConfigurations } from './configurations.hook';
import LoadingPage from 'src/components/loading-page/loading-page';
import LoadingButton from '@mui/lab/LoadingButton';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';
import { useMyDataStore } from 'src/store/me/me.store';

export default function ConfigurationsPage() {
  const {
    loadingPage,
    configList,
    loadingUpdate,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleUpdate,
  } = useConfigurations();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.configs)

  return (
    <Page title="Configurações">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs links={[]} heading="Configurações" />
        {loadingPage ? (
          <LoadingPage />
        ) : (
          <Card>
            <Stack spacing={2} p={4}>
              {configList.map((config, idx) => {
                if (config.type === 'Date') {
                  return (
                    <Stack key={`CONFIG_${idx}`} spacing={2}>
                      <Stack justifyContent="space-between" direction="row" alignItems="center">
                        <Typography variant="subtitle1">{config.description}</Typography>
                        <Stack direction="row" spacing={2} alignItems="center">
                          <DatePicker
                            sx={{
                              flex: 1,
                            }}
                            closeOnSelect
                            label="Data de Início"
                            slotProps={{
                              day: {
                                sx: {
                                  '&.MuiPickersDay-root.Mui-selected': {
                                    backgroundColor: 'primary.main',
                                  },
                                },
                              },
                            }}
                            value={startDate}
                            onChange={(v) => setStartDate(v)}
                          />
                          <DatePicker
                            sx={{
                              flex: 1,
                            }}
                            closeOnSelect
                            label="Data de Fim"
                            slotProps={{
                              day: {
                                sx: {
                                  '&.MuiPickersDay-root.Mui-selected': {
                                    backgroundColor: 'primary.main',
                                  },
                                },
                              },
                            }}
                            value={endDate}
                            onChange={(v) => setEndDate(v)}
                          />
                          <LoadingButton
                            loading={loadingUpdate}
                            variant="contained"
                            disabled={
                              !startDate ||
                              !endDate ||
                              moment(startDate).isAfter(moment(endDate)) ||
                              (startDate === config.value.startDate &&
                                endDate === config.value.endDate)
                              || !permissions?.update || !permissions.create
                            }
                            onClick={() => handleUpdate(config.name, { startDate, endDate })}
                          >
                            Salvar
                          </LoadingButton>
                        </Stack>
                      </Stack>
                      {idx !== configList.length - 1 && <Divider />}
                    </Stack>
                  );
                }

                if (config.type === 'Boolean') {
                  return (
                    <Stack key={`CONFIG_${idx}`} spacing={2}>
                      <Stack justifyContent="space-between" direction="row" alignItems="center">
                        <Typography variant="subtitle1">{config.description}</Typography>
                        <Stack direction="row" spacing={2} alignItems="center">
                          <Switch
                            disabled={!permissions?.create || !permissions.update}
                            checked={config.value}
                            onChange={(_, value) => handleUpdate(config.name, value)}
                          />
                        </Stack>
                      </Stack>
                      {idx !== configList.length - 1 && <Divider />}
                    </Stack>
                  );
                }

                return null;
              })}
            </Stack>
          </Card>
        )}
      </Container>
    </Page>
  );
}
